import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e1240e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "?", -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInfoBtn',
  props: {
    color: {},
    size: { default: '20' }
  },
  setup(__props: any) {

const props = __props;

const cssProps = computed(() => {
  return {
    '--color': props.color,
    '--size': props.size + 'px',
    '--font-size': `${+props.size - 4}px`,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "info-btn",
    style: _normalizeStyle(cssProps.value)
  }, _hoisted_2, 4))
}
}

})